module.exports = __webpack_public_path__ + "img/paper-6.950a2d8f.png";